import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-customs-tarifs',
  templateUrl: './customs-tarifs.component.html',
  styleUrls: ['./customs-tarifs.component.css']
})
export class CustomsTarifsComponent implements OnInit {
    public itemsListTarifs: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadTarifs(): Promise<void> {
        this.itemsListTarifs = await this.datatask.Post(1724);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'customstarif':
                this.stateService?.go('customstarif', { customstarif_id: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadTarifs();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('customsTarifs', {
//        templateUrl: 'views/components/views/customsTarifs/customsTarifs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'customsTarifsService', function (stateService, customsTarifsService) {
//            const vm = this;

//            vm.model = {
//                itemsListTarifs: []
//            };

//            async function loadTarifs() {
//                vm.model.itemsListTarifs = await customsTarifsService.listTarifs();
//            }

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'customstarif':
//                        go({ customstarif_id: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            }

//            vm.$onInit = function () {
//                loadTarifs();
//            }
//        }]
//    });
//})();
